import {
    AddressValidationParameter,
    ApiDataValue,
    applyAddressValidation,
} from "@aihCustomBlueprint/Services/AddressValidationService";
import { AIHActions } from "@aihCustomBlueprint/Store/CustomApplicationState";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<
    AddressValidationParameter & HasOnSuccess<ApiDataValue[]> & HasOnError<string>,
    ServiceResult<ApiDataValue[]>,
    DispatchProp<AIHActions>
>;

export const ExecuteHandler: HandlerType = async props => {
    props.apiParameter = { ...props.parameter };
    props.apiResult = await applyAddressValidation(props.apiParameter);
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [ExecuteHandler, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const validateAddress = createHandlerChainRunner(chain, "ValidateAddress");
export default validateAddress;
